import React from "react";
import dayjs from "dayjs";
import { Divider } from "antd";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";
import {
	CoupleName,
	DetailsHomeWrapper,
	EventContainer,
	ReceptionContainer,
} from "./component";

const DetailsHome = ({ details }) => {
	var utc = require("dayjs/plugin/utc");
	dayjs.extend(utc);
	return (
		<DetailsHomeWrapper tw="sm:(px-2 py-1) px-8 py-4">
			<CoupleName>
				<h2 tw="text-appPink font-bold mb-0!">
					<span tw="capitalize">
						{details?.bride_firstname?.slice(0, 1)}
					</span>{" "}
					and{" "}
					<span tw="capitalize">
						{details?.groom_firstname?.slice(0, 1)}
					</span>
				</h2>
				<p tw="font-semibold capitalize ">
					{" "}
					{details?.bride_firstname} {details?.groom_firstname}
				</p>
				<div tw="capitalize text-xs">{details?.venue}</div>
			</CoupleName>
			<Divider />
			<EventContainer>
				<div tw={"font-semibold"}>
					{dayjs().utc().format("DD MMM, YYYY HH:mm A")}
				</div>
				<p tw="uppercase font-light">Church Service</p>
				<div tw="capitalize text-sm">{details?.venue}</div>
			</EventContainer>
			<Divider />
			<ReceptionContainer>
				<div tw={"font-semibold"}>
					{dayjs().utc().format("DD MMM, YYYY HH:mm A")}
				</div>
				<p tw="uppercase font-light">Reception</p>
				<div tw="capitalize text-sm">{details?.venue}</div>
			</ReceptionContainer>
			<Divider />
			<span
				type="text"
				tw="h-12 relative flex justify-center items-center p-2 lowercase rounded-lg! text-base text-center text-appPink bg-appLightPink mb-4 w-full hover:(bg-appLightPink font-semibold text-appPinkSaturated shadow-md)">
				weddingstory.ng/{details?.page_url}
				<span tw="absolute right-2">
					<CopyToClipboard />
				</span>
			</span>
		</DetailsHomeWrapper>
	);
};

export default DetailsHome;
